import { publicApi } from '@/lib/api/publicClient';

/**
 * PRD §12 Reporter View — magic-link API.
 *
 * Reporters never create an account: they receive a 24h-scoped link after an
 * event closes (or earlier, per event policy). Hitting the link with a token
 * verifies it server-side and yields a scoped session for the four Reporter
 * tabs (Today / Inventory / Notes / Claims).
 *
 * Backend route (to be added in ox-platform): POST /reporter/magic-link/verify
 * with `{ token }` → `ReporterSession` or 401/410. The route lives outside the
 * JWT guard (it has its own short-lived bearer in the response).
 */
export interface ReporterSession {
  reporterId: number;
  name: string;
  email: string;
  // Scope: which event the reporter is allowed to see. v1 = single-event scope.
  eventId: number;
  eventName: string;
  // ISO timestamp; the link is rejected after this.
  expiresAt: string;
  // True until the reporter accepts the platform terms (PRD §13.6).
  termsRequired: boolean;
}

export const reporterApi = {
  verify: (token: string) =>
    publicApi.post<ReporterSession>('/reporter/magic-link/verify', { token }),

  acceptTerms: (token: string, version: string) =>
    publicApi.post<{ ok: true }>('/reporter/magic-link/accept-terms', {
      token,
      version,
    }),
};
